export default __webpack_public_path__ + "static/media/engagement.2abd0a36.jpg";